(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["uheat-flexgrid-calculator"] && !Shopify.designMode) return;
  try {
    class UheatFlexgridCalculator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.form = this.querySelector('[data-flexgrid-form]');
      this.results = this.querySelector('[data-flexgrid-results]');
      this.message = this.querySelector('[data-flexgrid-message]');
      this.cables = this.readData('[data-flexgrid-cables]').map((cable) => this.prepareCable(cable)).filter(Boolean);
      this.membranes = this.readData('[data-flexgrid-membranes]').map((membrane) => this.prepareMembrane(membrane)).filter(Boolean);
      this.recommendation = null;
      this.form?.addEventListener('submit', this.handleSubmit);
      this.querySelector('[data-apply-recommendation]')?.addEventListener('click', this.applyRecommendation);
    }

    readData(selector) {
      try {
        return JSON.parse(this.querySelector(selector)?.textContent || '[]');
      } catch (_error) {
        return [];
      }
    }

    prepareCable(cable) {
      const length = Number.parseFloat(cable.title?.match(/^(\d+(?:\.\d+)?)m/i)?.[1] || '');
      const wattage = Number.parseFloat(cable.title?.match(/\((\d+(?:\.\d+)?)W\)/i)?.[1] || '');
      const coverageByWattage = {
        105: .65,
        135: .84,
        165: .99,
        210: 1.27,
        265: 1.67,
        315: 1.98,
        405: 2.48,
        480: 2.95,
        550: 3.41,
        635: 3.94,
        815: 5.05,
        935: 5.83,
        1100: 6.82,
        1370: 8.37
      };
      const coverage = coverageByWattage[wattage];
      if (!length || !wattage || !coverage) return null;
      return { ...cable, id: String(cable.id), length, wattage, coverage };
    }

    prepareMembrane(membrane) {
      const area = Number.parseFloat(membrane.title?.match(/(\d+(?:\.\d+)?)m/i)?.[1] || '');
      if (!area) return null;
      return { ...membrane, id: String(membrane.id), area, price: Number(membrane.price) || 0 };
    }

    handleSubmit = (event) => {
      event.preventDefault();
      const roomArea = Number.parseFloat(this.querySelector('[data-room-area]')?.value || '');
      const heatedArea = Number.parseFloat(this.querySelector('[data-heated-area]')?.value || '');

      if (!roomArea || !heatedArea || roomArea <= 0 || heatedArea <= 0) {
        this.showError('Enter both the total room area and the heated floor area.');
        return;
      }
      if (heatedArea > roomArea) {
        this.showError('The heated area cannot be larger than the total room area.');
        return;
      }

      const cable = this.recommendCable(heatedArea);
      const membrane = this.recommendMembrane(roomArea);
      if (!cable) {
        this.showError('This heated area needs more than one cable or falls below the smallest available cable. Please ask our team to confirm the circuit layout.');
        return;
      }
      if (!membrane) {
        this.showError('A suitable membrane combination is not currently available. Please ask our team to confirm the quantities.');
        return;
      }

      this.recommendation = { cable, membrane };
      const targetOutput = Number(this.dataset.outputWattage) || 160;
      const requiredLength = heatedArea * targetOutput / 10;
      const actualOutput = Math.round(cable.wattage / heatedArea);

      this.querySelector('[data-cable-required]').textContent = `${this.formatNumber(requiredLength)}m at approximately ${targetOutput}W/m²`;
      this.querySelector('[data-membrane-required]').textContent = `${this.formatNumber(membrane.coverage)}m² total coverage`;
      this.querySelector('[data-recommended-cable]').textContent = cable.title;
      this.querySelector('[data-recommended-cable-note]').textContent = `Approximately ${actualOutput}W/m² across the heated area.`;
      this.querySelector('[data-recommended-membrane]').textContent = membrane.label;
      this.querySelector('[data-recommended-membrane-note]').textContent = `Covers ${this.formatNumber(membrane.coverage)}m² in total.`;
      this.results.hidden = false;
      this.showMessage('Recommendation calculated. Apply it to update the cable and membrane selectors.', 'success');
    };

    recommendCable(heatedArea) {
      const available = this.cables.filter((cable) => cable.available).sort((a, b) => a.coverage - b.coverage);
      if (!available.length || heatedArea < available[0].coverage || heatedArea > available.at(-1).coverage) return null;
      return [...available].reverse().find((cable) => cable.coverage <= heatedArea + .01) || null;
    }

    recommendMembrane(roomArea) {
      const options = this.membranes.filter((membrane) => membrane.available).sort((a, b) => b.area - a.area);
      if (!options.length) return null;
      const target = Math.ceil(roomArea);
      const maxArea = Math.max(...options.map((option) => option.area));
      const limit = target + maxArea;
      const states = Array(limit + 1).fill(null);
      states[0] = { cost: 0, count: 0, quantities: {} };

      for (let coverage = 0; coverage <= limit; coverage += 1) {
        const state = states[coverage];
        if (!state) continue;
        for (const option of options) {
          const nextCoverage = Math.min(limit, coverage + option.area);
          const quantities = { ...state.quantities, [option.id]: (state.quantities[option.id] || 0) + 1 };
          const candidate = { cost: state.cost + option.price, count: state.count + 1, quantities };
          const current = states[nextCoverage];
          if (!current || candidate.cost < current.cost || (candidate.cost === current.cost && candidate.count < current.count)) {
            states[nextCoverage] = candidate;
          }
        }
      }

      let best = null;
      for (let coverage = target; coverage <= limit; coverage += 1) {
        const state = states[coverage];
        if (!state) continue;
        const candidate = { ...state, coverage };
        if (!best || candidate.cost < best.cost || (candidate.cost === best.cost && candidate.coverage < best.coverage) || (candidate.cost === best.cost && candidate.coverage === best.coverage && candidate.count < best.count)) {
          best = candidate;
        }
      }
      if (!best) return null;

      const parts = options
        .filter((option) => best.quantities[option.id])
        .map((option) => `${best.quantities[option.id]} × ${option.title}`);
      return { ...best, label: parts.join(' + ') };
    }

    applyRecommendation = () => {
      if (!this.recommendation) return;
      const section = this.closest('.shopify-section') || document;
      const picker = section.querySelector('variant-picker[data-template-product-match="true"]') || section.querySelector('variant-picker');
      const nativeSelect = picker?.querySelector('select[data-uheat-variant-native]');
      if (!(nativeSelect instanceof HTMLSelectElement)) {
        this.showError('The recommendation is ready, but the cable selector could not be updated automatically.');
        return;
      }

      const cableOption = Array.from(nativeSelect.options).find((option) => option.value === this.recommendation.cable.title);
      if (!cableOption) {
        this.showError('The recommended cable is not available in the cable selector.');
        return;
      }

      nativeSelect.value = cableOption.value;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

      const membraneInputs = Array.from(section.querySelectorAll('uheat-product-addons [data-add-on-multi-quantity]'));
      for (const input of membraneInputs) {
        if (input instanceof HTMLInputElement) input.value = String(this.recommendation.membrane.quantities[input.dataset.addOnVariantId] || 0);
      }
      const selectedMembraneInput = membraneInputs.find((input) => input instanceof HTMLInputElement && Number(input.value) > 0);
      if (selectedMembraneInput instanceof HTMLInputElement) {
        selectedMembraneInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.showMessage('Cable and membrane quantities applied below.', 'success');
      const addOns = section.querySelector('uheat-product-addons');
      addOns?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    showError(copy) {
      this.recommendation = null;
      this.results.hidden = true;
      this.showMessage(copy, 'error');
    }

    showMessage(copy, state) {
      this.message.textContent = copy;
      this.message.dataset.state = state;
      this.message.hidden = false;
    }

    formatNumber(value) {
      return Number(value).toLocaleString('en-GB', { maximumFractionDigits: 2 });
    }
  }

  if (!customElements.get('uheat-flexgrid-calculator')) {
    customElements.define('uheat-flexgrid-calculator', UheatFlexgridCalculator);
  }
  } catch(e) { console.error(e); }
})();

})();
